import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapReligion extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapReligionOpened: false
       }
    }

    getReligionDisplayValue = (religion) => {
        let mappedReligion = this.props.mapOptions.filter(option => option.label === religion.label);
        if (mappedReligion.length > 0)
            return mappedReligion[0].label;
        else
            return '';
    }

    render() {
        let { allReligionMapping } = this.props.mapReligion;
        let {isMapReligionOpened} = this.state;
        let noOfReligionTypesMapped = allReligionMapping.filter(religionMapping => religionMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfReligionTypesMapped} of {allReligionMapping.length} values to religion categories</Col>
                <Col sm="1" md="1" className={isMapReligionOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapReligionOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapReligionOpened: !isMapReligionOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapReligionOpened}>
                 <div className="mt30 mapped-review-records">
                   {allReligionMapping.map((mappedReligion, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedReligion.value || mappedReligion.value===undefined||mappedReligion.value===null ||mappedReligion.value==="null"|| mappedReligion.value==="undefined"? 
                                mappedReligion.value="empty"
                                :
                                mappedReligion.value
                                } Religion type
                            </span>
                             {mappedReligion.column!=="" &&mappedReligion.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getReligionDisplayValue(mappedReligion.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
